'use strict';

module.exports = {
    WWW_URL: 'http://hrzp.putailai.com:26220'
};
